export const SuccessBanner = () => {

  return (
    <div>
      <h1>Erfolg!</h1>
      <h2>Deine Daten wurden erfolgreich abgeschickt</h2>
    </div>
  );
}